module.exports = __webpack_public_path__ + "images/category_lp/common/tile@2x_105ceb950e94e2dc0e22ed1df32ad34f.png";